import { useTheme } from "@mui/material/styles";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import "./studyHub.css";

export default function StudyShell({ children }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox className={dark ? "study-hub is-dark" : "study-hub"} py={2}>
        {children}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
